module.exports = __webpack_public_path__ + "static/img/153_TO8_1871_og.b7efcc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/153_TO8_1871_og.jpg
// module id = LmUR
// module chunks = 0